import { apiClient } from "helpers/api_helper";

export const GetRepairProductsList = async (data: any) => {
    try {
        const response = await apiClient.get(`/api/v1/Repair/GetRepairProductList`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};


export const getRepairReceipt = async (repairId: any) => {
    try {
        const response = await apiClient.get(`/api/v1/Repair/GenerateEstimateRepairReceipt?repairId=${repairId}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}
export const getRepairInvoice = async (repairId: any) => {
    try {
        const response = await apiClient.get(`/api/v1/Repair/GenerateRepairInvoice?repairId=${repairId}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export const generateRepairBag = async (data: any) => {
    try {
        const response = await apiClient.post(`/api/v1/Repair/GenerateRepairWorkItemBag`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export const getRepairProductBagList = async (data?: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Repair/GetRepairWorkBagList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}
export const getRepairedBagList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Repair/GetRepairWorkBagList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export const GenerateisStoreToMainStoreRepairChallan = async(data: any) =>{
     try {
        const response = await apiClient.get(`/api/v1/Repair/GenerateRepairChallan?isStoreToMainStore=${true}&bagId=${data}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export const GenerateRepairChallan = async(data: any) =>{
     try {
        const response = await apiClient.get(`/api/v1/Repair/GenerateRepairChallan?isStoreToMainStore=${false}&bagId=${data}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export const changeRepairProductStatus = async(data: any) =>{
     try {
        const response = await apiClient.post(`/api/v1/Repair/UpdateRepairBagStatus`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}
